<template>
	<div class="tab-view">
		<div :class="'tab' + (tab.name == modelValue ? ' active' : '')" v-for="(tab, i) in tabs" v-bind:key="i" @click.stop="(event) => { $emit('update:modelValue', tab.name, event); }">
			<div class="marker"></div>{{ tab.label }}<div class="badge" v-if="(tab.badge || 0) > 0">{{ tab.badge }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'tab-view',
		data() {
			return {

			};
		},
		props: {
			modelValue: {
				type: String,
				required: true
			},
			tabs: {
				required: true,
				type: Array
			}
		},
		watch: {
			tabs(newVal) {
				if (this.modelValue === null && newVal.length > 0) {
					this.$emit('update:modelValue', newVal[0].name);
				}
			}
		},
		created() {
			if (this.tabs.length > 0) {
				return this.tabs[0].name;
			} else {
				return null;
			}
		},
		methods: {
			test() {
				console.log('hmm');
			},
			tap(name) {
				console.log('tap!');
				this.$emit('update:modelValue', name);
			}
		},
		emits: ['update:modelValue']
	}
</script>

<style lang="scss" scoped>
	.tab-view {
		

		& > .tab {
			position: relative;
			cursor: pointer;
			line-height: 50px;
			height: 50px;
			font-size: 20px;
			padding-left: 20px;
			color: rgb(121, 121, 121);

			& > .badge {
				position: absolute;
				right: 20px;
				top: 50%;
				margin-top: -10px;
				height: 20px;
				min-width: 20px;
				background-color: #f7223f;
				border-radius: 10px;
				color: white;
				text-align: center;
				line-height: 20px;
				padding: 0 5px 0 5px;
			}

			&.active {
				color: white;

				& > .marker {
					position: absolute;
					left: 0;
					top: 50%;
					margin-top: -10px;
					height: 20px;
					background-color: #f7223f;
					width: 4px;
				}
			}
		}
	}
</style>